
export default {
    data() {
        return {
            paymentType: 'bank',
            steppers: 1,
        }
    },
}
